<template>
  <div class="content">
    <Carousel />
    <div class="contentCenter">
      <div class="title">
        <span>解决方案</span>
        <span>Business Solutions</span>
      </div>
      <div class="text">专注为政企园区、产业园区，以及各类场站、仓储库房等场所空间提供一体化综合运营管理解决方案</div>
      <div class="park">
        <div
          class="parkLi"
          v-for="(item, index) in picArr"
          v-lazy-container="{ selector: 'img' }"
          :key="index"
          @click="toDetails(item.toUrl)"
        >
          <div class="parkText">
            <img style="width: 100%; height: 100%" :data-src="item.url" alt="" />
          </div>
          <div class="parkTitle">{{ item.title }}</div>
        </div>
      </div>
      <div class="title" style="margin-top:0px;padding-top:100px;">
        <span>核心产品</span>
        <span>Key Products</span>
      </div>
      <div class="text">智慧园区操作系统、数字化应用软件</div>
    </div>
    <div class="system">
      <div class="systemCenter">
        <div class="systemLi" v-for="(item, index) in systemArr" :key="index" v-lazy-container="{ selector: 'img' }">
          <div class="logo">
            <img style="width: 59px; height: 59px" :data-src="item.url" alt="" />
          </div>
          <div class="systemTitle">{{ item.title }}</div>
          <div class="smallTitle">{{ item.text }}</div>
          <div class="btn1">
            <div
              class="btnli"
              v-for="(items, indexs) in item.btn"
              :key="indexs"
              :style="{
                'cursor': items == '了解详情' ? 'pointer' : 'not-allowed',
                'background-color': items == '了解详情' ? '#0171bb' : '#8d8d8d',
                'margin-left': indexs > 0 ? '24px' : '0px',
              }"
              @click="changeview(index)"
            >
              {{ items }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contentCenter">
      <div class="title">
        <span>技术能力</span>
        <span>Technical Capabilities</span>
      </div>
      <div class="text">
        针对园区及专业空间等场景，自主研发核心技术与算法，夯实大数据、人工智能、物联网等先进技术的应用落地 
      </div>
      <div class="technology">
        <div
          id="technology"
          class="technologyLi"
          v-for="(item, index) in technology"
          :key="index"
          :style="{
            'margin-top': index > 2 ? '15px' : '0px',
            background: index > 4 ? item.bg : '',
          }"
          @click="toDetail(index)"
        >
          <img
            v-if="index < 5"
            style="width: 100%; height: 100%"
            :src="item.url"
            alt=""
          />
          <div v-if="index < 5" class="img_desc">
            <div>{{ item.title }}</div>
            <div>
              {{ item.content }}
            </div>
          </div>
          <span v-if="item.text" class="learnMore">{{ item.text }}</span>
        </div>
      </div>
      <div class="title">
        <span>合作伙伴</span>
        <span>Cooperative Partners</span>
      </div>
      <div class="technology">
        <div
          class="partnerLi"
          v-for="(item, index) in partner"
          :key="index"
          :style="{ 'margin-top': index > 3 ? '15px' : '0px' }"
          v-lazy-container="{ selector: 'img' }"
        >
          <img :data-src="item.url" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "@/components/carousel";

export default {
  name: "homecontent",
  components: {
    Carousel,
  },
  data() {
    return {
      systemArr: [
        {
          text: "专为智慧园区打造的一体化综合管控操作系统",
          title: "“云将”系统",
          btn: ["了解详情"],
          url: require("../assets/leftLogo.png"),
        },
        {
          text: "提高企业、单位仓储建设智能化水平，优化仓储管理流程，提高物资利用效率...",
          title: "智慧无人仓",
          btn: ["了解详情"],
          url: require("../assets/wurencang.png"),
        },
        {
          text: "为园区、企业、楼宇、办公场所等提供无纸化、线上的访客登记薄",
          title: "便易访",
          btn: ["了解详情"],
          url: require("../assets/centerLogo.png"),
        },
      ],
      picArr: [
        {
          url: require("../assets/solution-2.png"),
          title: "政企园区",
          toUrl: "GovernmentEnterprisePark",
        },
        {
          url: require("../assets/solution-1.png"),
          title: "产业园区",
          toUrl: "productPark",
        },
        {
          url: require("../assets/solution-3.png"),
          title: "“碳中和”园区",
          toUrl: "carbinPark",
        },
        {
          url: require("../assets/solution-4.png"),
          title: "智慧无人仓",
          toUrl: "wisdomSmartWarehouse",
        },
      ],
      technology: [
        {
          title: "人脸识别",
          content:
            "人脸识别，是基于人的脸部特征信息进行身份识别的一种生物识别技术。用摄像机或摄像头采集含有人脸的图像或视频流。",
          url: require("../assets/one.png"),
        },
        {
          title: "人脸聚类",
          content:
            "人脸聚类是将一个集合内的人脸根据身份进行分组的算法， 人脸聚类也通过将集合内所有的人脸两两之间做人脸比对，再根据这些相似度值进行分析，将属于同一个身份的人划分到一个组里。",

          url: require("../assets/two.png"),
        },
        {
          title: "人脸检索",
          content:
            "人脸检索能够针对一个目标人脸,从已有的人脸集合中搜索并返回相似的人脸,同时还会返回相应的置信度分数与阈值,以供人工评估相似度。",

          url: require("../assets/three.png"),
        },
        {
          title: "跌倒检测",
          content:
            "不依靠穿戴设备和传感器，是一种基于深度学习图像处理的摔倒检测方法，对摄像头拍摄的视频或图片即可检测是否摔倒。",
          url: require("../assets/four.png"),
        },
        {
          title: "着装检测",
          content:
            "基于视频流的智能图像识别系统，利用最新的深度学习与大数据技术，代替人眼，自动识别各种违规行为，为安全生产保驾护航。",

          url: require("../assets/five.png"),
        },
        {
          text: "了解更多>>",
          bg: "#0171bb",
        },
      ],
      partner: [
        {
          url: require("../assets/shenzhen.png"),
        },
        {
          url: require("../assets/yidong.png"),
        },
        {
          url: require("../assets/guangda.png"),
        },
        {
          url: require("../assets/dianxin.png"),
        },
        {
          url: require("../assets/kele.png"),
        },
        {
          url: require("../assets/liantong.png"),
        },
        {
          url: require("../assets/liebao.png"),
        },
        {
          url: require("../assets/nengjian.png"),
        },
        {
          url: require("../assets/shenzhou.png"),
        },
        {
          url: require("../assets/taikang.png"),
        },
        {
          url: require("../assets/dianwang.png"),
        },
        {
          url: require("../assets/weishi.png"),
        },
      ],
    };
  },
  methods: {
    changeview(index) {
      if (index == 0) {
        this.$emit("changeview", "ProductCenter");
        document.documentElement.scrollTop = 430;
      } else if (index == 1) {
        this.$emit("changeview", "ProductCenter");
        document.documentElement.scrollTop = 1130;
      } else if (index == 2) {
        this.$emit("changeview", "ProductCenter");
        document.documentElement.scrollTop = 1830;
      }
    },
    toDetail(index) {
      if (index == 5) {
        this.$emit("changeview", "TechnicAlability");
        document.documentElement.scrollTop = 0;
      }
    },
    toDetails(e) {
      this.$emit("changeview", e);
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style scoped>
.learnMore {
  display: block;
  margin: 0 auto;
  width: 30%;
}
@media (max-width: 1200px) {
  .content {
    width: 100% !important;
    margin: 0;
  }
  .systemCenter {
    width: 100%;
  }
  .btn1 {
    font-size: small;
  }
  .systemTitle {
    height: 60px;
  }
  .smallTitle {
    height: 120px !important;
  }
  .system {
    border-top: none !important;
  }
}
.contentCenter {
  width: 1200px;
  margin: 0 auto;
}
@media (max-width: 1200px) {
  .contentCenter {
    width: 100%;
  }
}
.content {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #f2f4f8;
  padding-bottom: 80px;
  position: relative;
}

.systemCenter {
  width: 1200px;
  margin: 0 auto;
}
.system {
  background-color: #fff;
}

.title {
  text-align: center;
  margin-top: 100px;
  color: #333;
  font-size: 40px;
}
.title > span:nth-of-type(2) {
  color: #0171bb;
}
.text {
  text-align: center;
  font-size: 20px;
  color: #333;
  margin-top: 10px;
  /* font-weight: 400; */
}

.park {
  display: flex;
  justify-content: space-between;
  margin-top: 70px;
}
.parkLi {
  width: 280px;
  height: 276px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.parkText {
  height: 200px;
}
.parkTitle {
  height: 56px;
  line-height: 56px;
  text-align: center;
  background-color: #0171bb;
  font-size: 20px;
  color: #fff;
  margin-top: 20px;
}
.system {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  margin-top: 130px;
  padding-bottom: 6%;
}
.systemCenter {
  display: flex;
  justify-content: space-between;
}
.systemLi {
  position: relative;
  width: 32%;
}

.logo {
  width: 100px;
  height: 100px;
  position: absolute;
  text-align: center;
  line-height: 100px;
  color: #fff;
  font-size: 20px;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  background-color: #0171bb;
  display: flex;
  justify-content: center;
  align-items: center;
}
.systemTitle {
  font-weight: bold;
  font-size: 24px;
  color: #bdbdbd;
  text-align: center;
  margin-top: 125px;
}
@media (max-width: 800px) {
  .systemTitle {
    margin-top: 36%;
  }
}

.smallTitle {
  font-size: 16px;
  color: #bdbdbd;
  text-align: left;
  margin-top: 5%;
  height: 30%;
}
.btn1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.btnli {
  width: 144px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.technology {
  display: flex;
  margin-top: 70px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.technologyLi {
  width: 32%;
  height: 260px;
  font-size: 20px;
  color: #fff;
  transition: all 0.4s;
  position: relative;
  display: flex;
  align-items: center;
}
.technologyLi img {
  position: absolute;
}
.img_desc {
  width: 100%;
  height: 100%;
  background-color: #0171bb80;
  position: absolute;
  padding: 30px;
  padding-top: 60px;
  display: none;
}
.img_desc:hover {
  display: block;
}
.img_desc > div:nth-of-type(1) {
  font-size: 20px;
  font-weight: bold;
}
.img_desc > div:nth-of-type(2) {
  margin-top: 20px;
  font-size: 14px;
}
.technologyLi:hover {
  transform: scale(1.05);
}
#technology:hover > div {
  display: block;
  animation: fadeinout 0.6s linear forwards;
}
@keyframes fadeinout {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.partnerLi {
  width: 24%;
  height: 180px;
  background-color: #fff;
  transition: all 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
}
.partnerLi:hover {
  transform: scale(1.05);
}
@media (max-width: 1200px) {
  .systemCenter {
    width: 100%;
  }
  .btnli {
    margin: 0;
  }
  .systemTitle {
    margin-top: 50%;
  }
  .partnerLi {
    padding-left: 0;
  }
}
@media (max-width: 425px) {
  .content
    > div:nth-last-of-type(1)
    > div:nth-of-type(3)
    > div:nth-last-of-type(1) {
    margin-top: 10px !important;
  }
  .technologyLi {
    font-size: 14px;
    width: 100%;
    height: auto;
    margin-top: 10px !important;
  }
  .technologyLi img {
    object-fit: contain !important;
    position: relative;
  }
  .technology > div:nth-last-of-type(1) {
    height: auto;
    line-height: 50px;
  }
  .content {
    padding-bottom: 30px;
  }
  .park {
    flex-direction: column;
    margin-top: 50px;
  }
  .parkLi {
    width: 100%;
    height: auto;
  }
  .btnli {
    margin-left: 0 !important;
    padding: 0;
  }
  .btn1 > div:nth-of-type(2) {
    margin-left: 13px !important;
  }
  .partnerLi {
    overflow: hidden;
    margin-top: 10px !important;
    width: 46%;
  }
  .home_content {
    padding: 0 30px;
    font-size: 17px;
    line-height: 22px;
  }
  .text {
    padding: 0 20px;
    font-size: 12px;
  }
  .systemTitle {
    font-size: 16px;
  }
  .smallTitle {
    padding: 0 5px;
    font-size: 12px;
  }
  .title {
    margin-top: 50px;
    font-size: 20px;
  }
  .parkTitle {
    margin-top: 0;
    font-size: 15px;
    height: 40px;
    line-height: 40px;
    font-weight: 600;
  }
  .logo {
    width: 60px;
    height: 60px;
    top: -30px;
  }
  .logo img {
    width: 35px !important;
    height: 35px !important;
  }
  .btnli {
    font-size: 12px;
    width: 80px;
    height: 30px;
    line-height: 30px;
  }
  .learnMore {
    width: auto;
  }
  .img_desc > div:nth-of-type(2) {
    font-size: 12px;
  }
  .technology {
    justify-content: space-evenly;
  }
  .img_desc {
    /* display: block; */
    background-color: #0171bb40;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homecontent.vue